export default theme => ({
    socialGrid: {
        display: 'flex'
    },
    socialBlock: {
        margin: theme.spacing(3),
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center'
    }
});